// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"93d03149","3307":"93d03149","4964":"93d03149","5400":"93d03149","7934":"93d03149"}[chunkId] + ".chunk.css";
};